import type { SVGProps } from 'react';
const SvgArtLure = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 39 39" {...props}>
    <path d="M33 12.395c-4.802 5.068-16.933 4.573-21.947 1.86L6 18.79l1.929-6.394L6 6l5.053 4.534C16.473 7.98 28.564 7.326 33 12.394M33 28.026c-4.802 5.069-16.933 4.574-21.947 1.861L6 34.421l1.929-6.395L6 21.632l5.053 4.533c5.42-2.653 17.511-3.207 21.947 1.861" />
  </svg>
);
export default SvgArtLure;
